import {nowISOString} from 'app/demo/utils';

import {basic_account_owner_user_data_fixture} from './user_data';

import {ProcedureHashidSerializedType} from 'sweet-types';

export const procedure_detail_fixture: ProcedureHashidSerializedType = {
  id: 10,
  content_type: 'procedure',
  html_url:
    '/demo/procedures/o9C9/how-to-create-a-procedure-using-sweetprocess/',
  url: '/api/v1/procedures/10/',
  name: 'How to Create a Procedure using SweetProcess',
  slug: 'how-to-create-a-procedure-using-sweetprocess',
  tags: [
    {
      name: 'Marketing',
      slug: 'Marketing',
      html_url: '/procedures?tag=marketing',
      url: '/api/v1/taggeditems/6681458/',
    },
  ],
  // if you update the content below, remember to update the fake procedure diagram
  // in the /static/images/demo-procedure-generated-diagram.png file
  content: JSON.parse(
    '[{"title": "Log in and click the \\"Create Procedure\\" button", "n": 1, "id": "c6b2797a4ad294be74a7f158d8713e51", "content": "<img class=\\"fr-fic fr-dib\\" src=\\"18s08/642/a03db1e6/2018-08-21_2-00-41.png\\" style=\\"width: 56%;\\">", "files": [], "images": [], "image_ref": ""}, {"title": "Enter the title of the procedure.", "n": 2, "id": "6c3be4ed097d4c7f8d816e8aa29b7267", "content": "<img class=\\"fr-fic fr-dib\\" src=\\"18s10/642/944baa1d/2018-10-03_1-43-39.png\\">", "files": [], "images": []}, {"title": "Add the procedure to a team or multiple teams.", "n": 3, "id": "3d986f0b352640e1bf3574d31296624a", "content": "<img class=\\"fr-fic fr-dib\\" src=\\"18s10/642/98436f36/2018-10-03_2-27-13.png\\"><br>Click on a checkbox to add the procedure to a team or on multiple checkboxes to add the procedure to multiple teams at the same time. ", "files": [], "images": []}, {"title": "Click on the \\"Continue\\" button.", "n": 4, "id": "1454e5c7a0ee450b87853dd05a7722a9", "content": "<img class=\\"fr-fic fr-dib\\" src=\\"18s10/642/d5b1d7b9/2018-10-03_2-31-32.png\\" style=\\"width: 28%;\\">", "files": [], "images": []}, {"title": "Click on the title of the procedure to add a description.", "n": 5, "id": "4181daea9c0f163ed9d4e3311518accc", "content": "<img class=\\"fr-fic fr-dib\\" src=\\"18s10/642/7cf1c82e/2018-10-03_13-28-58.png\\" style=\\"width: 88%;\\">Click the Title area to begin editing.", "files": [], "images": [], "image_ref": ""}, {"title": "Enter some tags", "n": 6, "id": "7024b97aad4c806e16de2fc56f4f07b6", "content": "<img class=\\"fr-fic fr-dib\\" src=\\"18s08/642/4c6a30c6/2018-08-21_2-09-03.png\\" style=\\"width: 86%;\\">By making use of a tag, you will be assigning an index keyword/phrase/term to a procedure so that it can be quickly identified.", "files": [], "images": [], "image_ref": ""}, {"title": "Click on the \\"Add a Step\\" button", "n": 7, "id": "dd5ac504d6981b8a68d997945cc6156d", "content": "Click the \\"Add a Step\\" button to begin editing.<br><img class=\\"fr-fic fr-dib\\" src=\\"18s08/642/655945d7/2018-08-21_2-13-51.png\\" style=\\"width: 47%;\\">", "files": [], "images": []}, {"title": "Give the step a title & description", "n": 8, "id": "a333ea33d5d64e0fb1fb56015281dd1a", "content": "<img class=\\"fr-fic fr-dib\\" src=\\"18s10/642/14946bfd/2018-10-03_14-16-40.png\\">", "files": [], "images": []}, {"title": "Add images to the step", "n": 9, "id": "9eafd756d8f2fa7c833802c92d177f3f", "content": "<img class=\\"fr-fic fr-dib\\" src=\\"18s08/642/f6082404/2018-08-21_2-11-09.png\\" style=\\"width: 90%;\\">Drag and drop images from your computer into the image drop area.", "files": [], "images": [], "image_ref": ""}, {"title": "Click on \\u201cFinished editing\\u201d to save the draft of the step.", "n": 10, "id": "fe3400dd77be80366d2c5e7478ced1b7", "content": "<img class=\\"fr-fic fr-dib\\" src=\\"18s10/642/472e6c39/site_media_2Fmedia_2F18s08_2F642_2F5aa41855_2F2018-08-05_8-28-44.png\\" style=\\"width: 32%;\\">", "files": [], "images": [], "image_ref": ""}, {"title": "Click the \\u201cAdd a step\\u201d button to add a new step... Repeat steps 7, 8, 9 and 10 to enter and save the details of the new step.", "n": 11, "id": "58f666d0db3543fc867973322ccec9f5", "content": "", "files": [], "images": []}, {"title": "Repeat step 11 until you have added all the steps you need to document the procedure.", "n": 12, "id": "9d315ceb660b4af8abe6989c0461cc93", "content": "", "files": [], "images": []}, {"title": "Finished editing the draft of the procedure? Click the \\"Approve\\" button to make it the live version of the procedure.", "n": 13, "id": "2fa79828cdbb784c53583555760cb248", "content": "<img class=\\"fr-fic fr-dib\\" src=\\"18s08/642/5150443c/2018-08-21_2-24-41.png\\" style=\\"width: 62%;\\"><br><br><strong>Note:</strong> if you do not have the ability to approve the procedure, you will be able to request approval by clicking on the \\"<strong>Request Approval</strong>\\" button as shown below.<br><br><img class=\\"fr-fic fr-dib\\" src=\\"18s10/642/7299710a/2018-10-03_13-51-55.png\\" style=\\"width: 44%;\\">", "files": [], "images": [], "image_ref": ""}, {"title": "All done?  Click  on \\"Procedures\\"", "n": 14, "id": "7e65bcbec35c4d5f71fa0186a8c37a71", "content": "This will take you back to the dashboard, where you can manage all of your procedures.<br><img class=\\"fr-fic fr-dib\\" src=\\"18s08/642/79125066/2018-08-21_2-26-19.png\\" style=\\"width: 57%;\\"><br><br>", "files": [], "images": [], "image_ref": ""}]'
  ),
  description: JSON.parse(
    '{"content": "<strong>Hi there</strong>, here you can edit an example procedure. The full version of SweetProcess has more features than you can see here. For example uploading videos, adding form fields for your staff to capture data, attaching files and more. If you like what you see here, consider checking out the <a href=\\"/accounts/signup/\\">full version.</a>", "files": [], "images": [], "embeds": []}'
  ),
  hashid: 'o9C9',
  embed_url: '/embed/10/3cd573b00d1dc424a8a85cac5855c7a2/procedure/',
  author: basic_account_owner_user_data_fixture,
  original_author: basic_account_owner_user_data_fixture,
  approved_by: basic_account_owner_user_data_fixture,
  current_version: {
    id: 45,
    url: '/api/v1/procedureversions/45/',
    content_type: 'procedureversion',
    html_url:
      '/demo/procedures/o9C9/how-to-create-a-procedure-using-sweetprocess/version/45/',
  },
  managers: [basic_account_owner_user_data_fixture],
  policies: [],
  processes: [],
  team_memberships: [
    {
      url: '/api/v1/teamprocedures/19/',
      team: '/api/v1/teams/5/',
      direct: true,
      via_folder: false,
      html_url: '',
      via_name: '',
      via_process: false,
    },
    {
      url: '/api/v1/teamprocedures/20/',
      team: '/api/v1/teams/4/',
      direct: true,
      via_folder: false,
      html_url: '',
      via_name: '',
      via_process: false,
    },
  ],
  team_names: [],
  is_large: false,
  lanes: {},
  task_count: 0,
  account_id: 2,
  template_at: null,
  approved_at: nowISOString(),
  edited_at: nowISOString(),
  modified_at: nowISOString(),
  created_at: nowISOString(),
  can_edit: true,
  can_change: true,
  can_assign: true,
  can_export: true,
  last_review_at: null,
  next_review_at: null,
  private: true,
  steps_blocked_at: nowISOString(),
  review_period_months: 12,
  can_delete: true,
  connections: [],
  signoff_requested_at: null,
  signoff_requested_by: null,
  diagram_png_status: 'none',
  diagram_png_url: null,
  thumbnail: null,
};
